@if ( !!props.label && !hasGroups) {
<h2 class="mat-headline-2">{{props.label}}{{props.isRequired ? ' *' : ''}}</h2>
}
@if ( !!props.description && !hasGroups ) {
<span>{{props.description}}</span>
}
@for (propsByGroup of sortedGroups(); track propsByGroup ) {
<label [hidden]="true" [id]="props.label">{{'Select an option for' + props.label}}</label>
<mat-radio-group aria-labelledby="props.label"
    [value]="currentValue" [formControl]="formControl"
    [formlyAttributes]="field" (change)="onRadioChange($event)">
    <mat-expansion-panel [expanded]="!collapse[groupOrder[propsByGroup]]" [ngClass]="['mutara-radio-panel']">
        <mat-expansion-panel-header class="mat-expansion-panel-header">
            <h2 *ngIf='hasGroups' [ngClass]="'mat-headline-2'">
                {{groupOrder[propsByGroup]}}</h2>
        </mat-expansion-panel-header>
        <mat-expansion-panel-content [ngClass]="['mutara-expansion-panel-content','flex-full']">
            @for(radioOption of optionGroups[groupOrder[propsByGroup]]; track radioOption.value) {
            <mat-radio-button [disabled]='props?.readonly || props.disabled' [required]='props.required'
                [ngClass]="['mutara-radio-button']" [value]="radioOption.value">
                <markdown>{{radioOption.label}}</markdown>
            </mat-radio-button>
            }
        </mat-expansion-panel-content>
    </mat-expansion-panel>
</mat-radio-group>
}
@if (!!props.description ) {
<mat-hint>{{props.description}}</mat-hint>
}